import { Component, CUSTOM_ELEMENTS_SCHEMA,  effect,  ElementRef, inject, signal, viewChild, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { DialogSuccessErrorEditRouteData } from 'src/app/interfaces/mat.interface';
import { OverflowGradientService } from 'src/app/services/overflow-gradient.service';

@Component({
  selector: 'app-dialog-success-error-edit-route-response',
  standalone: true,
  imports: [
    TranslateModule
  ],
  templateUrl: './dialog-success-error-edit-route-response.component.html',
  styleUrls: ['./dialog-success-error-edit-route-response.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  encapsulation: ViewEncapsulation.None,
})
export class DialogSuccessErrorEditRouteResponseComponent {
  public successAccordion = viewChild<ElementRef>('successAccordion');
  public errorAccordion = viewChild<ElementRef>('errorAccordion');
  public successSection = viewChild<ElementRef>('successSection');
  public errorSection = viewChild<ElementRef>('errorSection');
  
  public data: DialogSuccessErrorEditRouteData = inject(MAT_DIALOG_DATA); 
  private _overflowGradienteService = inject(OverflowGradientService);
  
  public successAccordionOpen = signal(this.isSuccessList()); // abierto si hay success
  public errorAccordionOpen = signal(this.isOnlyErrorList()); // abierto solo si hay error
  
  setupOverflowGradient = effect(() => {
    if (!this.successSection() || !this.errorSection()) return;

    requestAnimationFrame(() => {
      const successSectionEl = this.successSection()?.nativeElement;
      if (successSectionEl) {
        this._overflowGradienteService.toggleVerticalGradient(successSectionEl);
      }

      const errorSectionEl = this.errorSection()?.nativeElement;
      if (errorSectionEl) {
        this._overflowGradienteService.toggleVerticalGradient(errorSectionEl);
      }
    });
  }, { allowSignalWrites: true });

  toggleAccordionExpansion = effect(() => {
    
  }, { allowSignalWrites: true });

  toggleAccordion(which: 'success' | 'error') {
    if (which === 'success') {
      this.successAccordionOpen.set(true);
      this.errorAccordionOpen.set(false);
    } else {
      this.successAccordionOpen.set(false);
      this.errorAccordionOpen.set(true);
    }
  }
    
  isOnlyErrorList(): boolean {
    return !this.isSuccessList() && this.isErrorList();
  }
  
  isSuccessList(): boolean {
    return this.data.content && this.data.content.successList && this.data.content.successList.length > 0;
  }
  
  isErrorList(): boolean {
    return this.data.content && this.data.content.errorList && this.data.content.errorList.length > 0;
  }
}
